import React, { Component } from "react";
import { StyleSheet, css } from "aphrodite";
import firebase from "firebase";
import Editar from "../modalEditarPromo";
import { Modal, Button, Image, Glyphicon, Panel } from "react-bootstrap";

export default class Card extends Component {
  constructor(props, context) {
    super(props, context);
    this.handleClose = this.handleClose.bind(this);

    this.state = {
      show: false
    };
  }
  handleClose() {
    this.setState({ show: false });
  }
  excluirPormocao(id) {
    firebase.auth().onAuthStateChanged(user => {
      firebase
        .database()
        .ref(`/promocoes/${user.uid}/${id}`)
        .remove()
        .then(() => {
          console.log("excluida", id);
        })
        .catch(erro => {
          console.log(erro);
        });
    });
  }
  render() {
    return (
      <section id={this.props.id}>
        <Panel className={css(styles.panelcustom)}>
          <div
            className={css(styles.container)}
            style={{ background: `url(${this.props.img})` }}
            onClick={() => this.setState({ show: true })}
          >
            <div className={css(styles.bkg)}>
              <p className={css(styles.title)}>{this.props.title}</p>
              <span>Postado: {this.props.data}</span>
              <span>Valor Promocional: {this.props.promocao}</span>
            </div>
          </div>
        </Panel>
        <Modal show={this.state.show} onHide={this.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>
              {this.props.title}{" "}
              <span className={css(styles.viewsModal)}>Válido: </span>{" "}
              <span>
                {this.props.active === "Ativa" ? (
                  <Glyphicon glyph="ok-sign" />
                ) : (
                  <Glyphicon glyph="remove-sign" />
                )}
              </span>
              <br />
              <span>Postado em: {this.props.data}</span>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <span className={css(styles.dataModal)}>Descrição:</span>
            <p>{this.props.text}</p>

            <p>
              <span className={css(styles.dataModal)}>Valor Promocional: </span>
              {this.props.promocao}
            </p>

            <Image
              src={this.props.img}
              responsive
              style={{ borderRadius: "4px" }}
            />
          </Modal.Body>
          <Modal.Footer className={css(styles.Footer)}>
            <Button
              onClick={() => this.excluirPormocao(this.props.id)}
              bsStyle="danger"
            >
              Excluir
            </Button>
            <Editar id={this.props.id} />

            <Button onClick={this.handleClose}>Fechar</Button>
          </Modal.Footer>
        </Modal>
      </section>
    );
  }
}
const styles = StyleSheet.create({
  bkg: {
    width: "100%",
    height: "auto",
    padding: "10px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    background: "rgba(0,0,0,0.6)",
    flexDirection: "column",
    justifyContent: "space-between",
    borderRadius: "4px",
    color: "#fff"
  },
  container: {
    width: "100%",
    height: "auto",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    borderRadius: "4px",
    backgroundSize: "400px",
    cursor: "pointer"
  },
  title: {
    fontSize: "2.1rem"
  },
  dataModal: {
    color: "#707070",
    fontSize: "1.5rem"
  },
  viewsModal: {
    color: "#707070",
    fontSize: "1.2rem"
  },
  panelcustom: {
    marginLeft: "10px",
    marginRight: "10px"
  },
  Footer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end"
  }
});



// WEBPACK FOOTER //
// ./src/assets/card/index.js